/**
 * assistantStore — assistente inteligente de buscas (porta de showNotification/
 * showSuggestions [application.js:3726/9145]). Controla o balão de nudge e o painel de
 * sugestões (overlay global).
 */
import { create } from 'zustand';

interface AssistantState {
  /** Painel de sugestões aberto. (O balão de nudge tem estado local no
   * SmartAssistantNotice — ele vive dentro do #window da captura.) */
  suggestionsOpen: boolean;
  openSuggestions: () => void;
  closeSuggestions: () => void;
}

export const useAssistantStore = create<AssistantState>((set) => ({
  suggestionsOpen: false,
  openSuggestions: () => set({ suggestionsOpen: true }),
  closeSuggestions: () => set({ suggestionsOpen: false }),
}));
